<template lang="html">
  <div :class="MainAuth.auth" id="app">
    <div :class="MainAuth.anun" :style="{backgroundImage:'url('+ mktDados.banner_login +')'}">
      <div>
        <h1>{{mktDados.title_login}}</h1>
        <p>
          {{mktDados.description_login}}
        </p>
        <br>
        <a target="_blank" :href="mktDados.url_button_login">
          <el-button>Saiba mais</el-button>
        </a>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import MainAuth from './MainAuth.scss?module';
import {searchSlug} from "@/app/domains/Auth/services";

export default {
  name: 'AuthMain',
  computed: {
    MainAuth() {
      return MainAuth;
    }
  },
  data() {
    return {
      mktDados: {
        "uri_logo": null,
        "title_login": "",
        "description_login": "",
        "banner_login": require('@/assets/images/bg-cappta.png'),
        "url_button_login": "https://www.google.com/",
        "slug": "cappta",
      }
    }
  },
  methods: {
    handleOpenDocs() {
      window.open('https://integration.cappta.com.br/', '_blank');
    }
  },
  async beforeCreate() {
    // 
    const loadingFull = this.$loading({
      background: 'rgb(255,255,255)'
    })
    const slug = window.location.host.split('.')[0]
    //colocar !== quando subir.
    if (slug !== 'localhost:8080') {
      // 
      if (slug !== 'www') {
        // 
        try {
          let responseSlug = await searchSlug(slug)
          if (responseSlug.data !== null) {
            this.$setTheme({
              colorPrimary: responseSlug.data.color_primary,
              colorSecondary: responseSlug.data.color_secondary,
            })
            this.mktDados = responseSlug.data
          }
          // 
        } catch (e) {
          console.log(e)
        } finally {
          loadingFull.close()
        }
      }
    } else {
      loadingFull.close()
    }
  },
}
</script>
